const exportEn = {
	export: {
		menuLabel: 'Export PDF',
		printLabel: 'Print',
		exportLabel: 'Export',
		dialogTitle: 'Export',
		pdf: 'Download PDF',
		csv: 'Download CSV',
		format: {
			label: 'Format',
			pdf: 'PDF',
			csv: 'CSV',
		},
		boolean: {
			yes: 'Yes',
			no: 'No',
		},
		groupColumn: 'Group',
		failed: 'Export failed.',
		fallbackTitle: 'Export',
		generatedAt: 'Generated at',
		pageOfPages: 'Page {current} of {total}',
		sort: 'Sort',
		activeFilters: 'Filter',
		searchTerm: 'Search',
		notesColumn: 'Note',
		context: {
			account: 'Account',
			accountType: 'Account type',
			building: 'Building',
			openingBalance: 'Opening balance',
			closingBalance: 'Closing balance',
			bookingsCount: 'Journals',
		},
		summary: {
			title: 'Summary',
			sumDebit: 'Σ Debit',
			sumCredit: 'Σ Credit',
			netAmount: 'Net for selection',
			selectionHint: '(based on the displayed entries)',
		},
		metadata: {
			tenant: 'Tenant',
			user: 'User',
			path: 'Path',
		},
		largeWarning:
			'The export contains {count} entries. This may take a moment.',
		scope: {
			selected: 'Selected only',
			currentPage: 'Current page only',
			all: 'All filtered entries',
		},
		includeNotes: {
			label: 'Add note column',
			hint: 'Appends an empty column on the right for handwritten notes.',
		},
		groupOnNewPage: {
			label: 'Start each group on a new page',
			hint: 'Forces a page break before every group. Otherwise groups only move to a new page if they would no longer fit.',
		},
		includeSubtables: {
			label: 'Include subtables',
			hint: 'Adds a smaller, indented table of linked entries (e.g. persons per user) underneath each main row.',
		},
		titles: {
			updateRequests: 'Update requests',
			meterLevels: 'Meter readings to release',
		},
	},
}

export default exportEn
